import React from "react";
import { useTranslation } from "react-i18next";
import { FORM_NAME } from "src/constant/common";

const ModalViewTarget = ({ simulationData }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  const targetData = [
    { key: "ascent_position", label: t(`new.target.${FORM_NAME.TARGET.ASCENT_POSITION}`), isArray: true },
    { key: "ascent_velocity", label: t(`new.target.${FORM_NAME.TARGET.ASCENT_VELOCITY}`), isArray: true },
    { key: "geodetic_lla0", label: t(`new.target.${FORM_NAME.TARGET.GEODETIC_LLA0}`), isArray: true },
    { key: "geodetic_llaf", label: t(`new.target.${FORM_NAME.TARGET.GEODETIC_LLAF}`), isArray: true },
    { key: "landing_velocity", label: t(`new.target.${FORM_NAME.TARGET.LANDING_VELOCITY}`), isArray: true },
  ];
  const targetObj = simulationData?.input_data?.target;
  return (
    <div className="m-3">
      {targetObj &&
        targetData.map(({ key, label, unit, isArray }) => {
          return (
            <div className="fw-bold mb-3" key={key}>
              <span>{label}</span>
              <span>{targetObj?.[key]?.unit ? ` (${unit || targetObj?.[key]?.unit}) = ` : " = "}</span>
              <span>{isArray ? `[${targetObj?.[key]?.value?.join(", ")}]` : targetObj?.[key]?.value}</span>
            </div>
          );
        })}
    </div>
  );
};

export default ModalViewTarget;
